// extracted by css-extract-rspack-plugin
export default {"mobileTooltipContent":"mobile-tooltip-content--VRpS2UsE_Lknq5Mh"};